(function() {
  vtex.define('shipping/script/component/AddressList',['flight/lib/component', 'shipping/script/setup/extensions', 'shipping/script/mixin/withi18n', 'shipping/script/mixin/withImplementedCountries', 'shipping/templates/addressList'], function(defineComponent, extensions, withi18n, withImplementedCountries, template) {
    var AddressList;
    AddressList = function() {
      this.defaultAttrs({
        data: {
          address: {},
          availableAddresses: [],
          deliveryCountries: ['BRA', 'ARG', 'CHL'],
          countryRules: {},
          loading: false,
          disableEdit: false
        },
        createAddressSelector: '.address-create',
        editAddressSelector: '.address-edit',
        addressItemSelector: '.address-list .address-item',
        submitButtonSelector: '.submit .btn-success'
      });
      this.render = function() {
        var _this = this;
        return dust.render(template, this.attr.data, function(err, output) {
          output = $(output).i18n();
          return _this.$node.html(output);
        });
      };
      this.createAddress = function() {
        if (this.attr.data.loading) {
          return;
        }
        return this.trigger('newAddress.vtex');
      };
      this.editAddress = function() {
        if (this.attr.data.loading || this.attr.data.disableEdit) {
          return;
        }
        this.attr.data.showDontKnowPostalCode = false;
        return this.trigger('editAddress.vtex', this.attr.data.address);
      };
      this.createAddressesSummaries = function() {
        var countriesUsedRequire,
          _this = this;
        countriesUsedRequire = _.map(this.attr.data.availableAddresses, function(a) {
          if (a.addressType === 'giftRegistry' || !a.country) {
            return null;
          } else if (_this.isCountryImplemented(a.country)) {
            return 'shipping/script/rule/Country' + a.country;
          } else {
            return 'shipping/script/rule/CountryUNI';
          }
        });
        return vtex.curl(countriesUsedRequire, function() {
          var aa, country, currentAddress, i, prop, state, _i, _j, _len, _len1, _ref, _ref1, _ref2, _ref3, _results;
          for (i = _i = 0, _len = arguments.length; _i < _len; i = ++_i) {
            country = arguments[i];
            prop = {};
            currentAddress = _this.attr.data.availableAddresses[i];
            if (currentAddress.addressType !== 'giftRegistry' && currentAddress.country) {
              prop[currentAddress.country] = new arguments[i]();
              _this.trigger(window, 'newCountryRule', prop);
              _this.addCountryRule(prop);
            }
          }
          _ref = _this.attr.data.availableAddresses;
          _results = [];
          for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
            aa = _ref[_j];
            aa.isSelected = aa.addressId === ((_ref1 = _this.attr.data.address) != null ? _ref1.addressId : void 0);
            aa.isGiftList = aa.addressType === "giftRegistry";
            if (aa.isSelected && aa.isGiftList) {
              _this.attr.data.disableEdit = true;
            }
            aa.firstPart = '' + aa.street;
            if (aa.number && aa.number !== 'N/A') {
              aa.firstPart += ', ' + aa.number;
            }
            if (aa.complement) {
              aa.firstPart += ', ' + aa.complement;
            }
            if (aa.neighborhood) {
              aa.firstPart += ', ' + aa.neighborhood;
            }
            if (aa.reference) {
              aa.firstPart += ', ' + aa.reference;
            }
            if ((_ref2 = _this.attr.data.countryRules[aa.country]) != null ? _ref2.isStateUpperCase : void 0) {
              state = aa.state;
            } else {
              state = _.capitalizeSentence(aa.state);
            }
            if (aa.city) {
              aa.secondPart = aa.city + ' - ' + state;
            } else {
              aa.secondPart = state;
            }
            if ((_ref3 = _this.attr.data.countryRules[aa.country]) != null ? _ref3.postalCodeByInput : void 0) {
              aa.secondPart += ' - ' + aa.postalCode;
            }
            _results.push(aa.secondPart += ' - ' + i18n.t('countries.' + aa.country));
          }
          return _results;
        });
      };
      this.selectAddressHandler = function(ev, data) {
        ev.preventDefault();
        return this.selectAddress($('input', data.el).attr('value'));
      };
      this.selectAddressByIdHandler = function(ev, id) {
        ev.stopPropagation();
        return this.selectAddress(id);
      };
      this.selectAddress = function(selectedAddressId) {
        var aa, _i, _len, _ref;
        _ref = this.attr.data.availableAddresses;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          aa = _ref[_i];
          if (aa.addressId === selectedAddressId) {
            this.attr.data.address = aa;
            aa.isSelected = true;
            if (aa.isGiftList) {
              this.attr.data.disableEdit = true;
              $('a', this.select('editAddressSelector')).addClass('disabled');
            } else {
              this.attr.data.disableEdit = false;
              $('a', this.select('editAddressSelector')).removeClass('disabled');
            }
          } else {
            aa.isSelected = false;
          }
        }
        this.trigger('addressSelected.vtex', this.attr.data.address);
        return this.render();
      };
      this.addCountryRule = function(data) {
        return _.extend(this.attr.data.countryRules, data);
      };
      this.enable = function(ev, deliveryCountries, shippingData, giftRegistryData) {
        var _this = this;
        if (ev) {
          ev.stopPropagation();
        }
        this.attr.data.loading = false;
        this.attr.data.deliveryCountries = deliveryCountries;
        this.attr.data.address = shippingData.address;
        this.attr.data.availableAddresses = shippingData.availableAddresses.filter(function(address) {
          return address.addressType;
        });
        this.attr.data.giftRegistryData = giftRegistryData;
        if (this.attr.data.availableAddresses.length > 0) {
          return this.createAddressesSummaries().then(function() {
            return _this.render();
          });
        }
      };
      this.disable = function(ev) {
        if (ev != null) {
          ev.stopPropagation();
        }
        return this.$node.html('');
      };
      this.startLoading = function(ev) {
        if (ev != null) {
          ev.stopPropagation();
        }
        $('a', this.select('createAddressSelector')).addClass('disabled');
        $('a', this.select('editAddressSelector')).addClass('disabled');
        return this.attr.data.loading = true;
      };
      this.stopLoading = function(ev) {
        if (ev != null) {
          ev.stopPropagation();
        }
        $('a', this.select('createAddressSelector')).removeClass('disabled');
        $('a', this.select('editAddressSelector')).removeClass('disabled');
        return this.attr.data.loading = false;
      };
      return this.after('initialize', function() {
        this.on('enable.vtex', this.enable);
        this.on('disable.vtex', this.disable);
        this.on('startLoading.vtex', this.startLoading);
        this.on('stopLoading.vtex', this.stopLoading);
        this.on('selectAddress.vtex', this.selectAddressByIdHandler);
        this.on('click', {
          'createAddressSelector': this.createAddress,
          'addressItemSelector': this.selectAddressHandler,
          'editAddressSelector': this.editAddress
        });
        return this.setLocalePath('shipping/script/translation/');
      });
    };
    return defineComponent(AddressList, withi18n, withImplementedCountries);
  });

}).call(this);

